import api from '../utils/api'

function authHeader() {
    const token = localStorage.getItem('token');
    return token ? { Authorization: `Bearer ${JSON.parse(token)}` } : {};
}

// Saldo consolidado do dia de abertura do chamado, para o código SAP dele.
// A primeira consulta de um dia processa a planilha no backend (~15s), por isso
// sem timeout no axios. Retorna:
//   { data, codSap, faltante, arquivo, saldo: { quantidades, total, saldoDRS } | null }
// - faltante: true  → não existe planilha para aquele dia
// - saldo: null     → dia processado, mas o código SAP não tinha peça disponível
export const getSaldoPorRequest = async (requestId) => {
    try {
        const { data } = await api.get(`/saldoconsolidado/request/${requestId}`, {
            headers: authHeader(),
            timeout: 0,
        });
        return data;
    } catch (error) {
        throw new Error(error.response?.data?.message || 'Erro ao buscar saldo consolidado.');
    }
}

const SaldoConsolidadoService = { getSaldoPorRequest };
export default SaldoConsolidadoService;
